var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.name }}},[_c('ion-icon',{attrs:{"name":_vm.icon}}),_vm._v(" "+_vm._s(_vm.title || _vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }